import { Dispatch } from "redux";
import {
  LOGIN_USER,
} from "../actionTypes/types";

export const AutoLogin = (userData: any) => (dispatch: Dispatch<any>) => {
  dispatch({ type: LOGIN_USER, payload: userData });
};